import r from "../managers/braze-instance.js";
export function requestImmediateDataFlush(e) {
  if (!r.rr()) return;
  const t = r.rn();
  t && t.requestImmediateDataFlush(e);
}
